var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuseumsandExhibits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f3faff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59,48.36c-.41,0-.75-.34-.75-.75v-26.19c0-.41.34-.75.75-.75s.75.34.75.75v26.19c0,.41-.34.75-.75.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1,48.36c-.41,0-.75-.34-.75-.75v-26.19c0-.41.34-.75.75-.75s.75.34.75.75v26.19c0,.41-.34.75-.75.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.64,51.81c-.08,0-.17-.01-.25-.04l-19.57-6.83s-.05-.01-.08-.02l-9.63-3.34c-.39-.14-.6-.56-.46-.95.14-.39.56-.6.95-.46l9.57,3.32s.05.01.08.02l19.63,6.85c.39.14.6.56.46.96-.11.31-.4.5-.71.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.29,55.26c-.08,0-.17-.01-.25-.04l-29.5-10.29c-.31-.1-.53-.38-.53-.72,0-.41.33-.75.74-.75h.02c.08,0,.17.01.25.04l29.52,10.3c.39.14.6.56.46.96-.11.31-.4.5-.71.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.36,51.81c-.31,0-.6-.19-.71-.5-.14-.39.07-.82.46-.96l19.64-6.85s.06-.02.08-.02l9.55-3.32c.39-.14.82.07.95.46.14.39-.07.82-.46.95l-9.62,3.34s-.05.02-.08.02l-19.58,6.83c-.08.03-.17.04-.25.04Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.71,55.26c-.31,0-.6-.19-.71-.5-.14-.39.07-.82.46-.96l29.52-10.3c.47-.16,1,.21,1.01.71,0,.36-.25.66-.58.73l-29.45,10.28c-.08.03-.17.04-.25.04Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.99,48.36c-.08,0-.17-.01-.25-.04l-28.75-10.02L1.25,48.31c-.39.14-.82-.07-.95-.46-.14-.39.07-.82.46-.95l28.99-10.1c.16-.06.33-.06.49,0l28.99,10.1c.39.14.6.56.46.95-.11.31-.4.5-.71.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30,59.04c-.09,0-.18-.02-.26-.05L.74,48.31c-.3-.11-.5-.41-.49-.73s.23-.6.54-.69c.17-.05.35-.03.5.03l28.71,10.58,28.67-10.56c.16-.08.34-.1.53-.04.31.09.53.37.55.69s-.18.62-.49.73l-29,10.68c-.08.03-.17.05-.26.05Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m53.37,25.75c-.41,0-.75-.34-.75-.75V7.68c0-.41.34-.75.75-.75s.75.34.75.75v17.32c0,.41-.34.75-.75.75Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.63,31.57c-.41,0-.75-.34-.75-.75v-13.44c0-.41.34-.75.75-.75s.75.34.75.75v13.44c0,.41-.34.75-.75.75Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "secondary"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.75,33.38c-.41,0-.75-.34-.75-.75v-7.78c-1.08.32-2.22.47-3.35.41-1.66.08-3.37-.28-4.9-1.05v8.43c0,.41-.34.75-.75.75s-.75-.34-.75-.75v-8.43c-1.53.77-3.26,1.14-4.98,1.06-1.09.06-2.2-.08-3.27-.4v7.78c0,.41-.34.75-.75.75s-.75-.34-.75-.75v-8.12c0-.08.01-.15.03-.23-.46-.22-.91-.49-1.34-.78-.34-.24-.42-.7-.19-1.04.24-.34.71-.42,1.04-.19,1.52,1.06,3.37,1.58,5.22,1.49,1.92.1,3.77-.43,5.29-1.49.25-.18.63-.18.87,0,1.52,1.05,3.37,1.58,5.21,1.49,1.92.09,3.78-.43,5.3-1.49.34-.24.81-.15,1.04.19.24.34.15.81-.19,1.04-.43.3-.87.56-1.34.78.02.07.04.15.04.23v8.12c0,.41-.34.75-.75.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "primary"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m43,19.75h-26c-.41,0-.75-.34-.75-.75V6c0-.41.34-.75.75-.75h26c.41,0,.75.34.75.75v13c0,.41-.34.75-.75.75Zm-25.25-1.5h24.5V6.75h-24.5v11.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuseumsandExhibits);
export default __webpack_public_path__ + "static/media/Museums and Exhibits.77f99255fd5934587cf103a7abdc098b.svg";
export { ForwardRef as ReactComponent };